import { Indicator, rem, type IndicatorProps } from '@mantine/core'
import { ArrowFatLinesUpIcon, ArrowFatLineUpIcon, ArrowFatUpIcon, ArrowUpIcon } from '@phosphor-icons/react'
import type { ReactNode } from 'react'

import { IconGlyph } from '~/boggle/ui/atoms/Icons'

type UnviewedItemIndicatorProps = {
  active: boolean
  children: ReactNode
  testId?: string
}

const NEW_LABEL_INDICATOR_STYLES: IndicatorProps['styles'] = {
  indicator: {
    paddingBlock: rem(8),
    paddingInline: rem(6),
  },
}

const IMPROVED_ARROW_INDICATOR_STYLES: IndicatorProps['styles'] = {
  indicator: {
    alignItems: 'center',
    borderRadius: '50%',
    display: 'flex',
    height: rem(18),
    justifyContent: 'center',
    minHeight: rem(18),
    minWidth: rem(18),
    padding: 0,
    width: rem(18),
  },
}

/** Red "New" label beside a lexicon word (middle-end placement). */
export function UnviewedNewWordIndicator({
  active,
  children,
  testId,
}: UnviewedItemIndicatorProps) {
  return (
    <Indicator
      color="red"
      data-testid={testId}
      disabled={!active}
      inline
      label="New"
      offset={{ x: -24, y: 0 }}
      position="middle-end"
      processing={false}
      size={12}
      styles={NEW_LABEL_INDICATOR_STYLES}
      zIndex={4}
    >
      {children}
    </Indicator>
  )
}

/** Red "New" label on the top-right of a compendium badge medallion. */
export function UnviewedNewBadgeIndicator({
  active,
  children,
  testId,
}: UnviewedItemIndicatorProps) {
  return (
    <Indicator
      color="red"
      data-testid={testId}
      disabled={!active}
      inline
      label="New"
      offset={{
        x: 10,
        y: 4,
      }}
      position="top-end"
      processing={false}
      size={12}
      styles={NEW_LABEL_INDICATOR_STYLES}
      zIndex={4}
    >
      {children}
    </Indicator>
  )
}

/** Yellow up-arrow on the top-right of a compendium badge medallion. */
export function UnviewedImprovedBadgeIndicator({
  active,
  children,
  testId,
}: UnviewedItemIndicatorProps) {
  return (
    <Indicator
      color="red"
      data-testid={testId}
      disabled={!active}
      inline
      offset={{
        x: 4,
        y: 4,
      }}
      label={
        <IconGlyph
          // color="var(--mantine-color-yellow-2)"
          color="white"
          icon={ArrowFatLinesUpIcon}
          size={12}
          weight="fill"
          style={{
            // stroke: 'var(--mantine-color-yellow-9)',
            // strokeWidth: 10,
          }}
        />
      }
      position="top-end"
      processing={false}
      size={18}
      styles={IMPROVED_ARROW_INDICATOR_STYLES}
      zIndex={4}
    >
      {children}
    </Indicator>
  )
}
